module.exports = __webpack_public_path__ + "img/crew_operator.fbd9fdd2.svg";